/**
 * Форматирует оценку с одной цифрой после точки (например `5.0`).
 */
export default function formatRatingScore(value: number): string {
  return value.toFixed(1)
}
